import PowerDate from '#metatypes/power_date.js'
import { define, type, auto, Record, Collection } from 'type-r'
import { ContactCollection } from '#models/contact'
import ValidRecord from '#models/valid_record'
import DOB from '#metatypes/dob.js'

@define
export default class AuthorizationDisclosureForm extends ValidRecord {
    @(type(String).required.as) provider: string
    @(type(String).required.as) memberId: string
    @(type(String).required.as) subscriberName: string
    @(type(DOB).required.as) subscriberDob: string
    @(type(ContactCollection).as) authorizedContacts: ContactCollection
    @(type(null).required.as) signature: any
}